import * as React from "react";

const LayoutModalContext = React.createContext({
  onHide() {},
});

export default LayoutModalContext;
